import { BuyCloudSiteSetupPageTemplate } from "../../../../templates/buy/cloud/site-setup/src";

export const BuyCloudSiteSetupPage = () => <BuyCloudSiteSetupPageTemplate />;
